import type {Pointer, PS} from '@wix/document-services-types'
import dataModel from '../dataModel/dataModel'
import dataSerialization from '../dataModel/dataSerialization'
import appControllerUtils from './appControllerUtils'
import constants from '../constants/constants'

const {DATA_TYPES} = constants

function getControllerDataItem(ps: PS, controllerRef: Pointer) {
    appControllerUtils.verifyController(ps, controllerRef)
    if (controllerRef.type === DATA_TYPES.data) {
        return dataModel.getDataItemById(ps, controllerRef.id)
    }
    return dataModel.getDataItem(ps, controllerRef)
}

function setControllerDataItem(ps: PS, controllerRef: Pointer, dataItem, useOriginalLanguage = false) {
    appControllerUtils.verifyController(ps, controllerRef)

    if (controllerRef.type === DATA_TYPES.data) {
        const pageId = ps.pointers.data.getPageIdOfData(controllerRef)
        dataSerialization.addSerializedItemToPage(ps, pageId, dataItem, controllerRef.id, DATA_TYPES.data)
        return
    }
    dataModel.updateDataItem(ps, controllerRef, dataItem, useOriginalLanguage)
}

export default {
    getControllerDataItem,
    setControllerDataItem
}
